import type { AppDefinition } from '../types';

/** Daftra — accounting workspace. No connector yet. */
export const DAFTRA_APP: AppDefinition = {
  id: 'daftra',
  nameKey: 'apps.daftra.name',
  descriptionKey: 'apps.daftra.description',
  logo: '/images/apps/daftra-logo.svg',
  categories: ['accounting'],
  status: 'soon',
  label: 'soon',
};
